import PropTypes from 'prop-types';
export const ratingStarsPropTypes = {
  ratingCount: PropTypes.number,
  ratingScore: PropTypes.number
};